export default "__VITE_ASSET__DMbybiQI__"